import { Exam } from '@/interfaces/exam';
import { ExamResource, examResource } from '@/resources/exam.resource';
import store from '../store';
import { EntityModule } from './entity.module';
import results from './exam/examResult.module';

/**
 * Moduł egzaminów
 *
 * @export
 * @class ExamModule
 * @extends {EntityModule<Exam, ExamResource>}
 */
export class ExamModule extends EntityModule<Exam, ExamResource> {
  public modules = { results };
  constructor() {
    super(examResource);
    this.mutations = {
      ...this.mutations,

      /**
       * Dodaje do listy
       *
       * @param {*} localState
       * @param {Exam} entity
       */
      add(localState: any, entity: Exam): void {
        const sport = store.getters['sport/byId'](entity.sportId);
        entity.sport = sport;
        localState.list.unshift(entity);
      },

      /**
       * Aktualizuje liste
       *
       * @param {*} localState
       * @param {Exam} entity
       */
      update(localState: any, entity: Exam): void {
        const sport = store.getters['sport/byId'](entity.sportId);
        entity.sport = sport;
        const index = localState.list.findIndex((item: Exam) => item.id === entity.id);
        localState.list.splice(index, 1, entity);
      }
    };
  }
}

export default new ExamModule();
